import map from 'lodash/map';
import remove from 'lodash/remove';

import { ServiceError } from './EasyClaimServiceError';

/**
 * A method decorator that appropriately converts a low level exception on network or protocol level into an ServiceError,
 * which should be handled by the application.
 */
export function ServiceErrorAdapter() {
	return (target: any, propertyName: string, propertyDescriptor: TypedPropertyDescriptor<any>) => {
		const decoratedMethod = propertyDescriptor.value;

		propertyDescriptor.value = async function (...args: any[]) {
			try {
				return await decoratedMethod.apply(this, args);
			} catch (error) {
				const response = error as Response;
				let json: any | undefined;

				try {
					json = await response.json();
					// tslint:disable-next-line: no-empty
				} catch (e) {}
				// eslint-disable-next-line
				throw {
					details: json
						? remove(
								map(json, (value, key) => ({ key, value })),
								(data) => data.value
							)
						: [],
					responseStatus: response.status,
					responseStatusText: response.statusText,
				} as ServiceError;
			}
		};

		return propertyDescriptor;
	};
}
